import React, { FC, useState } from 'react';
import { Typography } from 'fronton-react';
import { greyRoundedSquare, routesTextRow } from './styles';

type Props = {
  label: string;
  icon: JSX.Element;
  iconActive: JSX.Element;
  onClick?: () => void;
  qa: string;
};

export const RouteBlock: FC<Props> = ({ label, icon, iconActive, onClick = undefined, qa = '' }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      className={routesTextRow}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
      onKeyDown={onClick}
      data-qa={qa}
    >
      <div className={greyRoundedSquare}>{hover ? iconActive : icon}</div>
      <Typography color="text-primary" variant="m" size="body_accent">
        {label}
      </Typography>
    </div>
  );
};
